import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[760px] lg:min-h-[860px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20dark%20navy%20industrial%20rubber%20engineering%20background%20with%20precision%20black%20rubber%20components%20gears%20and%20technical%20blueprint%20lines%20glowing%20faintly%2C%20cinematic%20moody%20lighting%2C%20deep%20blue%20tones%2C%20editorial%20engineering%20aesthetic%2C%20clean%20composition%20with%20strong%20negative%20space%20on%20the%20left%20for%20text%20overlay%2C%20premium%20B2B%20manufacturing%20brand%20visual&width=1800&height=1100&seq=krubber-hero-bg-01&orientation=landscape"
          alt="산업용 고무제품 엔지니어링 배경"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-transparent to-foreground-950/40" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 pt-40 lg:pt-48 pb-24">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-background-50/25 bg-background-50/5 backdrop-blur-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400" />
            <span className="text-[11px] tracking-[0.2em] uppercase text-background-50/85">
              Since {siteInfo.established} · Engineering Partner
            </span>
          </div>

          <h1 className="mt-7 font-heading font-extrabold text-background-50 text-[40px] sm:text-5xl lg:text-[64px] leading-[1.08] tracking-tight">
            고무제품에<br />
            <span className="text-accent-300">문제가 있으신가요?</span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-background-50/80 leading-relaxed max-w-2xl">
            {siteInfo.experienceYears}년 이상의 기술력으로 고객의 문제를 해결합니다.<br className="hidden sm:block" />
            도면이 없어도 괜찮습니다. 함께 분석하고, 함께 만들어 드립니다.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors text-sm font-semibold cursor-pointer whitespace-nowrap"
            >
              제품 문의하기
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
            <Link
              to="/about/overview"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border border-background-50/35 text-background-50 hover:bg-background-50/10 transition-colors text-sm font-semibold cursor-pointer whitespace-nowrap"
            >
              회사 소개 보기
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line" />
              </span>
            </Link>
          </div>

          <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-2xl">
            {[
              { label: "Years of Experience", value: "50+" },
              { label: "Industries Served", value: "20+" },
              { label: "Custom Products", value: "1,200+" },
              { label: "Quality Pass Rate", value: "99.7%" },
            ].map((s) => (
              <div key={s.label} className="border-l border-background-50/15 pl-4">
                <div className="font-heading font-extrabold text-background-50 text-2xl lg:text-3xl">
                  {s.value}
                </div>
                <div className="mt-1 text-[11px] tracking-[0.15em] uppercase text-background-50/55">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="hidden lg:flex absolute bottom-10 right-10 z-10 items-center gap-3 text-background-50/70 text-xs tracking-[0.2em] uppercase">
        <span>Scroll</span>
        <span className="w-10 h-px bg-background-50/40" />
      </div>
    </section>
  );
}